<div class="error-dialog">
  <button [mat-dialog-close]="data.id" class="icon-close error-dialog__close-button focus-outline"></button>
  <h1>{{ data.headline }}</h1>
  <p>
    {{ data.text1 }} <span class="chargeport-error">{{ data.id }}</span> {{ data.text2 }}
  </p>
  <div class="centered">
    <button class="button-filled-primary close-button" [mat-dialog-close]="data.id" cdkFocusInitial>
      {{ data.button }}
    </button>
  </div>
</div>
